import React from 'react';
import { CircularProgress } from '@mui/material';
import styled from 'styled-components';
import { ASSETS } from '../../utils/config';
import { goToUrl } from '../../utils/helpers';
import TextView from '../TextView';
import { fileIcons } from '../../constants/documentIcon';

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
`;

const IconView = styled.div`
  width: 34px;
  height: 40px;
  display: flex;
  justify-content: flex-start;
`;

const Icon = styled.img`
  width: 34px;
  height: 40px;
  object-fit: fill;
`;

const DocumentPreview = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;

  /* Uncomment if needed for thumbnail styling */
  /* ${(props) =>
    props.showThumbnail &&
    `
      background: #f1f4fb;
      border-radius: 8px;
      padding: 10px;
      justify-content: center;
  `} */
`;


const DocumentItem = ({ doc, showThumbnail }) => {
  if (doc.loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <CircularProgress size={28} />
      </div>
    );
  }

  return (
    <DocumentPreview showThumbnail={showThumbnail} onClick={() => goToUrl(doc?.src)}>
      <Row>
        <IconView>
          <Icon src={fileIcons[doc?.type]} />
        </IconView>
        <TextView variant="largeText" style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', }}>{doc?.title?.length > 20 ? doc?.title?.slice(0, 40) + '...' : doc?.title}</TextView>
      </Row>
    </DocumentPreview>
  );
};

export default DocumentItem;
